// extracted by mini-css-extract-plugin
module.exports = {"colorWildSand":"#F6F7F9","colorAsphalt":"#66708E","colorUIBlack10":"#e7e9eb","colorUIBlack20":"#d0d3d8","sortMenu":"SortDropdownMenu-module__sortMenu___2kSge"};